const generateBackgroundColor = (omit = '') => {
    let colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

    colors = TB.reject(colors, omit);

    return TB.first(TB.shuffle(colors))
}


import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import InfoTooltip from './InfoTooltip';
import { Tooltip } from 'antd';
import { Img } from 'react-image';
import LoadingSpinner from './LoadingSpinner';
import { useAuth } from '../providers/AuthProvider';

const _getInitials = (data) => {
    if (data != null) {
        let chr;
        const d = data.toUpperCase();
        chr = d.split(" ");
        if (chr.length >= 2) {
            return chr[0][0] + chr[1][0];
        } else {
            return d[0] + d[1];
        }
    }
    return "";
}

// by default, unavailable dot is not shown if talent is unavailable - use showUnavailable prop to show red dot if talent is unavailable

const UserImageCircle = ({ className = '', size = 30, user = {}, showUnavailable, ...props }) => {
    const { auth } = useAuth();

    const COLORS = {
        // [TB.config('color.primary')]: 'white',
        // [TB.config('color.secondary')]: 'white',
        // [TB.config('color.success')]: 'black',
        // [TB.config('color.info')]: 'white',
        // [TB.config('color.warning')]: 'black',
        // [TB.config('color.danger')]: 'white',
        // [TB.config('color.primary-light')]: 'white',
        // [TB.config('color.secondary-light')]: 'white',
        [TB.config('color.success-light')]: 'black',
        [TB.config('color.info-light')]: 'white',
        [TB.config('color.warning-light')]: 'black',
        [TB.config('color.danger-light')]: 'white',
        // [TB.config('color.primary-lighter')]: 'white',
        [TB.config('color.secondary-lighter')]: 'white',
        [TB.config('color.success-lighter')]: 'black',
        [TB.config('color.info-lighter')]: 'white',
        [TB.config('color.warning-lighter')]: 'black',
        [TB.config('color.danger-lighter')]: 'white',
        // [TB.config('color.primary-lightest')]: 'white',
        // [TB.config('color.secondary-lightest')]: 'white',
        // [TB.config('color.success-lightest')]: 'black',
        // [TB.config('color.info-lightest')]: 'white',
        // [TB.config('color.warning-lightest')]: 'black',
        // [TB.config('color.danger-lightest')]: 'white',
        // [TB.config('color.primary-dark')]: 'white',
        // [TB.config('color.secondary-dark')]: 'white',
        // [TB.config('color.success-dark')]: 'black',
        // [TB.config('color.info-dark')]: 'white',
        // [TB.config('color.warning-dark')]: 'black',
        // [TB.config('color.danger-dark')]: 'white',
        '#ADB1B5': 'white', // gray
    }
    const getInitials = (data) => {
        if (data != null) {
            let chr;
            const d = data.toUpperCase();
            chr = d.split(" ");
            if (chr.length >= 2) {
                return chr[0][0] + chr[1][0];
            } else {
                return d[0] + d[1];
            }
        }
        return "";
    }
    const getColorForInitial = (letter = "") => {
        if (!letter?.length) return Object.keys(COLORS)[1];
        if (className.includes('img-grayscale')) return Object.keys(COLORS)[Object.keys(COLORS).length - 1];
        let code = letter.toUpperCase().charCodeAt(0);

        if (code > 64 && code < 91) {
            code -= 64;
            let activeColors = [
                ...Object.keys(COLORS),
                ...Object.keys(COLORS),
                ...Object.keys(COLORS)
            ]
            let randomIndex = Math.floor((code / 26) * activeColors.length);
            return activeColors[randomIndex];
        }
    }

    const isMissingImage = useMemo(() => {
        // return true
        return !user?.image_path || String(user.image_path).includes('default-user')
    }, [user.image_path]);

    const bgColor = useMemo(() => {
        return getColorForInitial(TB.first(user.label || user?.first_name || user.last_name))
    }, [user?.first_name, user.label]);

    const circleBgStyle = useMemo(() => {

        if (!isMissingImage && !props.initialsOnly) {
            return { backgroundImage: `url('${user.image_path}')` }
        }

        if (String(user.label || user?.first_name || user.last_name).length > 0) {
            return { backgroundColor: bgColor, filter: 'none' }
        }

        return {}
    }, [user?.image_path]);

    if (!user) return null;

    let {
        hideTooltip,
        initialsOnly,
        ...tooltipProps
    } = { ...(props || {}) }


    // use this to show for all users, not just self talent (also remove useAuth when switching back)
    // const isTalent = user.isTalent?.() || user.is_talent;
    // const isTalent = (user.isTalent?.() || user.is_talent) && auth.id === user.id;
    const confirmedAvailabilityForOpportunities = user.hasConfirmedAvailabilityForOpportunities?.()


    const isTalent = user.isTalent?.() || user.is_talent;
    // const confirmedAvailabilityForOpportunities = true

    // console.log(user.first_name, confirmedAvailabilityForOpportunities, ' --- --- --- -- --- --')

    return (
        <div>

            <div className="relative group" id={`user-image-circle-${user.id}`}>
                <div
                    data-toggle={hideTooltip ? undefined : "tooltip"}
                    data-placement="top"
                    // title={user && user.firstNamePlusInitial?.()}
                    className={"user-image-circle " + className}
                    style={{ minWidth: size, width: size, minHeight: size, height: size, ...circleBgStyle }}
                    {...tooltipProps}
                >
                    <div
                        className={TB.mapClass('user-image-circle h-full w-full', {
                            'bg-black transition-all duration-500 bg-opacity-0 group-hoverbg-opacity-50': isTalent,
                        })}
                    >
                        {(initialsOnly || isMissingImage) && (
                            <div className="initials" style={{ color: COLORS[bgColor], fontSize: `calc(${parseInt(size) ? `${size}px` : size} / 3)` }}>
                                {getInitials(user?.label || user?.fullName?.())}
                            </div>
                        )}
                    </div>
                </div>
                {isTalent && (confirmedAvailabilityForOpportunities || showUnavailable) && (
                    <div
                        className={TB.mapClass('bg-white group-hoverbg-black group-hoverbg-opacity-50 group-hover:scale-[1.3] transition-all duration-500 h-4 w-4 flex items-center justify-center rounded-full absolute', {
                            'bottom-2 right-2': size >= 110,
                            'bottom-1 right-1': size >= 61 && size <= 109,
                            '-bottom-1 -right-1': size <= 60,
                        })}
                    >
                        <div
                            className={TB.mapClass(' h-2.5 w-2.5 rounded-full', {
                                'bg-green-500': confirmedAvailabilityForOpportunities,
                                'bg-amber-600': !confirmedAvailabilityForOpportunities,
                            })}
                        />
                    </div>
                )}
            </div>
            {isTalent && (confirmedAvailabilityForOpportunities || showUnavailable) && (
                <InfoTooltip target={`user-image-circle-${user.id}`} type="dark" placement="top">
                    <p className="text-white p-0">
                        {user.first_name} {confirmedAvailabilityForOpportunities ? 'recently confirmed availability for job assignments' : 'is unavailable'}
                    </p>
                </InfoTooltip>
            )}
        </div>
    )
}

UserImageCircle.propTypes = {
    user: PropTypes.any,
    size: PropTypes.any,
    className: PropTypes.any,
    initialsOnly: PropTypes.any,
};

export default UserImageCircle;

// POSSIBLY USE THIS TO UTILIZE REACT-IMG PACKAGE WITH USERIMAGECIRCLE COMPONENT

const INITIALS_COLORS = {
    [TB.config('color.success-light')]: 'black',
    [TB.config('color.info-light')]: 'white',
    [TB.config('color.warning-light')]: 'black',
    [TB.config('color.danger-light')]: 'white',
    [TB.config('color.secondary-lighter')]: 'white',
    [TB.config('color.success-lighter')]: 'black',
    [TB.config('color.info-lighter')]: 'white',
    [TB.config('color.warning-lighter')]: 'black',
    [TB.config('color.danger-lighter')]: 'white',
    '#ADB1B5': 'white',
};

const _getInitialsColor = (letter = '', isGrayscale = false) => {
    const keys = Object.keys(INITIALS_COLORS);
    if (!letter?.length) return keys[1];
    if (isGrayscale) return keys[keys.length - 1];
    const code = letter.toUpperCase().charCodeAt(0);
    if (code > 64 && code < 91) {
        const tripled = [...keys, ...keys, ...keys];
        const index = Math.floor(((code - 64) / 26) * tripled.length);
        return tripled[index];
    }
    return keys[1];
};

export const UserImageCircleNEW = ({ user, statusImage, showAvailabilityDot, showOpenToWork, grayscale, initialsOnly, className }) => {
    const isTalent = user.isTalent?.() || user.is_talent;
    const confirmedAvailabilityForOpportunities = user.hasConfirmedAvailabilityForOpportunities?.()

    const isMissingImage = useMemo(() => {
        return !user?.image_path || String(user.image_path).includes('default-user')
    }, [user.image_path]);

    const bgColor = useMemo(() => {
        return _getInitialsColor(TB.first(user.label || user?.first_name || user.last_name), false);
    }, [user?.first_name, user.label, className]);

    const hasSizeClass = /(?:^|\s)!?(?:h-|w-|size-)/.test(className);
    const defaultSize = hasSizeClass ? '' : 'h-20 w-20';
    const textSizeClass = className?.match(/text-\[?[^\s]+/)?.[0] || 'text-xl';

    const InitialsFallback = () => (
        <div
            className="h-full w-full rounded-full flex items-center justify-center"
            style={{ backgroundColor: bgColor }}
        >
            <span className={`font-bold ${textSizeClass}`} style={{ color: INITIALS_COLORS[bgColor] || 'white' }}>
                {_getInitials(user?.label || user?.fullName?.())}
            </span>
        </div>
    );

    return (
        <Tooltip
            placement="top"
            color="#000"
            title={isTalent && showOpenToWork && confirmedAvailabilityForOpportunities ? `${user.firstNamePlusInitial?.()} recently confirmed availability for job assignments` : null}
        >
            <div className={`${defaultSize} relative group flex items-center justify-center ${className}`} id={`user-image-circle2-${user.id}`}>
                {(initialsOnly || isMissingImage) ? (
                    <InitialsFallback />
                ) : (
                    <Img
                        loader={
                            <div className="loading-user-image">
                                <LoadingSpinner size="lg" />
                            </div>
                        }
                        src={user?.image_path}
                        unloader={<InitialsFallback />}
                        className={TB.mapClass("img-fluid rounded-full", { 'img-grayscale': grayscale })}
                        alt={`Profile image for ${user.firstNamePlusInitial?.() || ''}`}
                    />
                )}

                {statusImage && (
                    <img alt="" src={statusImage} className="absolute" />
                )}

                {isTalent && showAvailabilityDot && confirmedAvailabilityForOpportunities && (
                    <div
                        className={TB.mapClass('bg-white border border-green-400 group-hoverbg-black group-hoverbg-opacity-50 group-hover:scale-[1.3] transition-all duration-500 h-4 w-4 flex items-center justify-center rounded-full absolute', {
                            'bottom-1.5 right-1.5': true,
                        })}
                    >
                        <div
                            className={TB.mapClass('h-2.5 w-2.5 rounded-full', {
                                'bg-green-500': true,
                            })}
                        />
                    </div>
                )}

            </div>
        </Tooltip>
    )
}


UserImageCircleNEW.defaultProps = {
    initialsOnly: false,
    showAvailabilityDot: true,
    showOpenToWork: true,
    grayscale: true,
}

UserImageCircleNEW.propTypes = {
    user: PropTypes.any,
    size: PropTypes.any,
    className: PropTypes.any,
    initialsOnly: PropTypes.bool,
    showAvailabilityDot: PropTypes.bool,
    showOpenToWork: PropTypes.bool,
    grayscale: PropTypes.bool,
};

// USAGE:
//     <UserImageCircleNEW
//         user={user}
//         className="!h-[56px] !w-[56px] font-xs" (sets height/width, font-[size] sets fallback text font size)
//         showAvailabilityDot={false}
//         showOpenToWork={false}
//         grayscale={false}
//     />